const Encode = {
  UTF_8: 'UTF-8',
  SHIFT_JIS: 'Shift-JIS',
}

export default Encode
